import { useOidcStore } from "vue3-oidc";
import { Configuration } from "@socotec.io/document-sdk";
import { Configuration as CertipersBackConfiguration } from "@socotec.io/certipers-back-sdk";
import { Configuration as QuestionnaireConfiguration } from "@socotec.io/questionnaire-sdk";

const tokenGetter = () => {
  return useOidcStore().state.value.token;
};

const documentConfig = new Configuration({
  basePath: import.meta.env.VITE_APP_DOCUMENT_REST_API_URL,
  accessToken: tokenGetter,
});

const certipersBackConfig = new CertipersBackConfiguration({
  basePath: import.meta.env.VITE_APP_CERTIPERS_REST_API_URL,
  accessToken: tokenGetter,
});

const questionnaireConfig = new QuestionnaireConfiguration({
  basePath: import.meta.env.VITE_APP_QUESTIONNAIRE_REST_API_URL,
  accessToken: tokenGetter,
});

export default { documentConfig, certipersBackConfig, questionnaireConfig };
